import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    hr: {
      borderBottom: '1px solid #efefef!important',
      width: '90%',
      borderStyle: 'none',
    },
    bannerShop: {
      [theme.breakpoints.down('sm')]: {
        width: 60,
        height: 60,
      },
      width: 65,
      height: 65,
      borderRadius: 10,
      objectFit: 'cover',
      cursor: 'pointer',
    },
    gridRequestMainShop: {
      border: '1px solid #efefef',
      borderRadius: 10,
      width: '85%!important',
      padding: '10px 5px',
      marginBottom: '10px!important',
    },
    gridRequest: {
      borderBottom: '1px solid #efefef',
      borderRadius: 10,
      padding: '0px 0 0px 0',
    },
    gridRequestPhotoText: {
      display: 'flex',
    },
    titleRequestShop: {
      color: '#292d32',
      fontSize: 16,
      fontWeight: 300,
      margin: '0px!important',
    },
    textDesRequestShop: {
      margin: '0px!important',
      fontSize: 11,
      color: '#7c7c7c',
    },

    textDesRequest: {
      margin: '5px 5px!important',
      fontSize: 13,
      color: '#7c7c7c',
    },
    textDesRequestTotal: {
      margin: '0px 5px!important',
      fontSize: 13,
      color: '#7c7c7c',
    },
    textDesRequestTotalValue: {
      margin: '0px 0px 0 0px!important',
      fontSize: 13,
      color: '#a51713',
    },
    gridStatusRequest: {
      backgroundColor: '#fff5c7',
      color: '#ff8a00',
      fontSize: 12,
      padding: '2px 5px',
      borderRadius: 15,
    },
    textStatusRequest: {
      margin: '0px!important',
    },

    gridRequestMainProduct: {
      borderRadius: 10,
      padding: '5px 5px 0 5px',
    },
    bannerProduct: {
      [theme.breakpoints.down('sm')]: {
        width: 45,
        height: 45,
      },
      width: 50,
      height: 50,
      borderRadius: 10,
      objectFit: 'cover',
    },
    titleRequestProduct: {
      color: '#292d32',
      fontSize: 15,
      margin: '0px!important',
    },
    textDesRequestProduct: {
      margin: '0px!important',
      fontSize: 11,
      color: '#7c7c7c',
    },
    textValueRequestProduct: {
      color: '#292d32',
      fontWeight: 550,
    },
    gridBtnRequestProduct: {
      width: '100%',
    },
    btnRequestProductFollow: {
      marginTop: '15px!important',
      width: '100%',
      height: 28,
      borderRadius: '10px!important',
      backgroundColor: '#a51713!important',
    },
    iconBtnRequestProduct: {
      marginRight: 10,
    },

    btnRequestProductDetail: {
      marginTop: '15px!important',
      width: '100%',
      height: 28,
      border: '1px solid rgb(210 25 25 / 50%)!important',
      borderRadius: '10px!important',
    },
    textBtnRequestProductDetail: {
      color: '#a51713',
    },
    btnRequestProductRate: {
      marginTop: '15px!important',
      marginLeft: '10px!important',
      backgroundColor: '#a51713!important',
      width: 30,
      padding: '0px!important',
      minWidth: '30px!important',
      height: 30,
    },

    gridTitleId: {
      width: '90%!important',
    },
    textTitleId: {
      margin: '0px 0!important',
    },
    gridContainerShopItem: {
      width: '100%!important',
      marginTop: 10,
    },
    gridContentShop: {
      width: '85%!important',
    },
    gridContentShopItem: {
      width: '85%!important',
    },
    gridDesShop: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'end',
      justifyContent: 'space-between',
    },
    textShopLight: {
      color: '#767474',
      fontSize: '12px!important',
      margin: '5px 0!important',
      textAlign: 'left',
      marginRight: '10px!important',
    },
    textShopNormal: {
      color: '#781414',
      fontSize: 13,
      margin: '5px 0!important',
    },

    textShopOptionFlavorAddtional: {
      color: '#781414',
      fontSize: 12,
      margin: '0px 0!important',
    },

    gridObservationMain: {
      marginTop: '15px!important',
      borderRadius: 10,
      border: '1px solid #bf5b59!important',
      width: '80%',
    },
    gridObservation: {
      display: 'flex',
      padding: '10px 10px 0 10px',
    },
    titleObservation: {
      marginLeft: '10px!important',
      color: '#b33d39',
      margin: '0px!important',
    },
    textArea: {
      width: '100%',
      height: '100px',
      border: 'none!important',
    },

    titleModal: {
      textTransform: 'uppercase',
      margin: '10px 0!important',
    },
    textModal: {
      textAlign: 'center',
      marginBottom: '15px!important',

      color: '#a8a8a8',
    },
    iconModal: {
      width: 60,
      height: 60,
    },

    btnSubmit: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      textTransform: 'uppercase',
      width: '100%',
      maxWidth: '680px',
      borderRadius: '10px!important',
      color: '#FFF!important',
    },
    textBtnSubmit: {
      textTransform: 'uppercase',
      margin: '0px!important',
      marginRight: '10px!important',
    },

    imgBase64Pix: {
      width: 100,
      height: 100,
    },
    textBtnCopyPix: {
      margin: '0px!important',
      textTransform: 'uppercase',
      fontSize: 13,
    },
    textBtnCopyPixUpload: {
      margin: '0px!important',
      textTransform: 'uppercase',
      fontSize: 13,
      color: '#000',
    },
    titlePix: {
      margin: '5px!important',
    },
    descriptionPix: {
      margin: '5px!important',
      fontSize: 13,
    },
    textTempLimitPix: {
      fontSize: 11,
    },

    inputFile: {
      display: 'none',
    },
    uploadReceiptpixInput: {
      color: 'white !important',
      backgroundColor: '#7a69ed !important',
      padding: '10px !important',
      borderRadius: '8px !important',
      fontWeight: 600,
      textTransform: 'uppercase',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      display: 'flex',
      width: '100%',
    },
    uploadReceiptPix: {
      cursor: 'pointer',
      width: '100%',
    },
    iconImage: {
      marginRight: 10,
      width: 30,
      height: 30,
    },
    imagePreview: {
      height: 260,
      width: '100%',
      objectFit: 'contain',
    },
    textInfoUploadFilePix: {
      margin: '20px 20px!important',
      color: '#646363',
      fontWeight: 550,
      fontSize: 13,
    },
    btnCopyPix: {
      backgroundColor: '#FCD3D3!important',
      color: '#292d32',
      margin: '0px 0!important',
    },

    btnChat: {
      backgroundColor: '#b7b5b5!important',
      height: 20,
      width: 50,
      borderRadius: '7px!important',
      color: '#fff!important',
    },
    btnChatRed: {
      backgroundColor: '#a51713!important',
      height: 20,
      width: 50,
      borderRadius: '7px!important',
      color: '#fff!important',
    },
    btnChatRedCicle: {
      backgroundColor: '#a51713!important',
      position: 'sticky',
      bottom: '80px',
      right: '10px',
      float: 'right',
      width: '40px',
      height: '40px',
      borderRadius: '50%!important',
      padding: '0px!important',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      cursor: 'pointer',
    },
    imgIconChatCicle: {
      width: 22,
    },
    imgIconChat: {
      width: 15,
      marginRight: 5,
    },

    gridChatContainer: {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
    },
    titleChat: {
      width: '90%',
      fontSize: 14,
    },
    segTitleChat: {
      width: '90%',
      margin: '0px!important',
      fontSize: 13,
      color: '#7c7c7c',
    },
    descrChat: {
      margin: '0px 0px 15px 0px!important',
      width: '90%',
      fontSize: 13,
      color: '#7c7c7c',
    },
    btnToChat: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      padding: '5px 0px',
      width: '80%',
      borderRadius: '10px!important',
      color: '#FFF!important',
      border: 'none',
      cursor: 'pointer',
    },

    gridChatIframeContainer: {
      width: '100%',
      display: 'flex',
      height: '88vh',
    },
    iframe: {
      width: '100%',
      marginBottom: '10px',
      border: 'none',
    },
    contentChangeFormPayment: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '10px 0px',
    },
    btnChangeFormPayment: {
      width: '85%',
      borderRadius: '10px!important',
      backgroundColor: '#FFF!important',
      border: 'solid 1px #FCD3D3!important',
      color: '#444!important',
    },
  }),
);

export default useStyles;
